module.exports = "/fonts/intelliboard.woff?6257479e2c2b4d1248a64c9baddf8f31";